import { Button } from "@growtherapy/sprout-ui";
import { useTranslate } from "@growtherapy/i18n";
import { useSetAtom } from "jotai";
import { useCallback } from "react";
import type { PageComponentProps } from "../../../../components";
import { visitorDrawerStateAtom } from "../../../../visitor/state";
import {
  useMoodCheckinSelectionsState,
  useMoodCheckinCustomResponseState,
} from "./useMoodCheckinSelectionsState";
import { useSyncMoodCheckinChoicesCallback } from "./useSyncMoodCheckinChoicesCallback";
import { usePreSessionPromptState } from "../../../waiting-room/pre-session-prompt/usePreSessionPromptState";

export function Actions({
  isFirstPage,
  prevPage,
}: PageComponentProps<string[]>) {
  const t = useTranslate();
  const [selections] = useMoodCheckinSelectionsState();
  const [customResponse, setCustomResponse] =
    useMoodCheckinCustomResponseState();
  const onSyncChoices = useSyncMoodCheckinChoicesCallback();
  const setDrawerState = useSetAtom(visitorDrawerStateAtom);
  const { clearPreSessionPrompt } = usePreSessionPromptState();

  const onSaveAndCloseDrawer = useCallback(() => {
    const emotionsToSync = customResponse.trim()
      ? [...selections, customResponse.trim()]
      : selections;

    if (!emotionsToSync.length) return;

    onSyncChoices(emotionsToSync, {
      onCompleted() {
        setCustomResponse("");
        setDrawerState(null);
        clearPreSessionPrompt();
      },
    });
  }, [
    onSyncChoices,
    selections,
    customResponse,
    setCustomResponse,
    setDrawerState,
    clearPreSessionPrompt,
  ]);

  return (
    <>
      {!isFirstPage && (
        <Button onClick={prevPage} use="secondary">
          {t("telehealth-core:moodCheckin.previous")}
        </Button>
      )}
      <Button onClick={onSaveAndCloseDrawer}>
        {t("telehealth-core:moodCheckin.saveAndClose")}
      </Button>
    </>
  );
}
